<div [ngClass]="spinnerClasses"></div>